<template>
    <v-dialog v-model="isActive" width="400px" scrollable transition="dialog-bottom-transition" persistent>
        <v-card class="rounded-0 pa-4">
            <!--  <v-card-title class="font-weight-bold text-h4 justify-center">
                ATENCIÓN</v-card-title> -->
            <v-card-text class="d-flex align-center justify-center flex-column text-body-1 black--text pa-5">
                <v-icon size="120" color="orange">mdi-alert-outline</v-icon>
                <!-- Por favor, revise si su número de matrícula es correcto antes de continuar. -->
                {{ msg }}
                <div class="font-weight-bold primary--text text-h3 pt-5 " v-if="msg.includes('matrícula')">
                    {{ matricula }}
                </div>
            </v-card-text>
            <div class="d-flex flex-column justify-center align-center text-center">
                <v-btn class="pa-5" width="180" elevation="0" color="primary" @click="confirmAndClose(true)">
                    {{ msgAceptar }}
                </v-btn>
                <v-btn class="pa-5 mt-1 " width="180" outlined color="secondary" @click="confirmAndClose(false)">
                    {{ msgCancelar }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['msgAceptar', 'msgCancelar', 'msg'],
    data() {
        return {
            isActive: false,
            callback: null,
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['matricula']),
    },
    methods: {
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    }
}

</script>